import { ThunkResult } from ".."
import { SET_PERMISSIONS } from "./types"
import axios from "axios"
import { API_URL } from "../../api/Definitions"
import { SET_USER_PERMISSIONS } from "../user/types"

export function getPermissions(): ThunkResult<Promise<void>> {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${API_URL}/v1/permissions-list`)
        .then((res) => {
          dispatch({ type: SET_PERMISSIONS, payload: res.data })
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
}

export function getUserPermissions(): ThunkResult<Promise<void>> {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(`${API_URL}/v1/user-permissions`)
        .then((res) => {
          dispatch({ type: SET_USER_PERMISSIONS, payload: res.data })
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
}
